(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaia-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section gaia-header');
    document.documentElement.style.setProperty('--header-height', `${parseInt(header.offsetHeight)}px`);

    var headerObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        document.documentElement.style.setProperty('--header-height', `${parseInt(header.offsetHeight)}px`);
      }
    });

    // Observe one or multiple elements
    headerObserver.observe(header);
  });

  } catch(e) { console.error(e); }
})();
})();
